// extracted by mini-css-extract-plugin
export default {"contactSection":"Contact_contactSection__j6N9B","contactContainer":"Contact_contactContainer__BOLJ8","formContainer":"Contact_formContainer__Ax0-b"};